// NOTE: these styles are based off of the signal sauce date time picker styles
// with some modifications and all time related styles removed

import { createTheme } from "@material-ui/core";
import { theme } from "./theme";

const { color } = theme;

const datePickerStyleOverrides = {
  MuiInputBase: {
    input: {
      fontFamily: theme.fontFamily,
      border: "none !important",
      color: color.black,
      "&:hover": {
        borderBottom: "none",
      },
      "&:disabled": {
        opacity: "0.5",
      },
    },
    root: {
      fontFamily: theme.fontFamily,
      fontSize: "16px",
    },
  },
  MuiSvgIcon: {
    root: {
      fontSize: "15px",
    },
  },
  MuiPickersDay: {
    daySelected: {
      backgroundColor: color.grayDarkest,
      "&:hover": {
        backgroundColor: color.grayDark,
      },
    },
    dayDisabled: {
      color: color.grayLightest,
    },
    current: {
      color: color.grayDarkest,
    },
  },
  MuiPickersToolbar: {
    toolbar: {
      backgroundColor: color.grayDarkest,
    },
  },
  MuiPickersToolbarText: {
    toolbarTxt: {
      color: color.grayDark,
    },
    toolbarBtnSelected: {
      color: color.white,
    },
  },
  MuiTypography: {
    body1: {
      fontFamily: theme.fontFamily,
      fontSize: "16px",
    },
    body2: {
      fontFamily: theme.fontFamily,
      fontSize: "12px",
    },
    caption: {
      fontFamily: theme.fontFamily,
      fontSize: "12px",
    },
    colorPrimary: {
      fontFamily: theme.fontFamily,
      color: color.green,
    },
    h3: {
      fontFamily: theme.fontFamily,
      fontSize: "30px",
    },
    h4: {
      fontFamily: theme.fontFamily,
      fontSize: "34px",
    },
    h5: {
      fontFamily: theme.fontFamily,
      fontSize: "15px",
    },
    subtitle1: {
      fontFamily: theme.fontFamily,
      fontSize: "16px",
    },
  },
  MuiInput: {
    input: {
      borderBottom: "none",
    },
    underline: {
      borderBottom: `1px solid #6A7B85`,
      "&::after": {
        borderBottom: "none",
      },
      "&:active": {
        borderBottom: "none",
      },
    },
  },
  MuiFormLabel: {
    root: {
      color: "#6A7B85",
      fontFamily: theme.fontFamily,
      fontSize: "14px",
      "&$focused": {
        color: color.grayDark,
      },
    },
  },
};

export default createTheme({
  overrides: datePickerStyleOverrides,
});
